const KEY = "mall.source";

/** How the shopper got to the shop, so a shop can see what its signs are actually doing. */
export const markSource = (via) => {
    try { if (via) sessionStorage.setItem(KEY, via); } catch { /* private mode */ }
};

export const readSource = () => {
    try { return sessionStorage.getItem(KEY) || "direct"; } catch { return "direct"; }
};
